module.exports = __webpack_public_path__ + "img/chevron-double-left.8a9c4604.svg";